export const status_update_compose_display = {
  heading: "Post status update",
  post_update: "Post update",
  post_update_error: "Could not post status update",
};
